import { render, staticRenderFns } from "./PanelTabs.vue?vue&type=template&id=453adf2f"
import script from "./PanelTabs.vue?vue&type=script&lang=js"
export * from "./PanelTabs.vue?vue&type=script&lang=js"
import style0 from "./PanelTabs.vue?vue&type=style&index=0&id=453adf2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports